import { BaseWorkflowPanel } from "./BaseWorkflowPanel";
import { BoundaryBox } from "../BoundingBoxEditor";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Info } from "lucide-react";

interface WorkflowProps {
  device: any;
  deviceId: string;
  questionValue: string;
  onQuestionChange: (v: string) => void;
  onSaveQuery: () => void;
  onGenerateQuery: () => void;
  onSaveBoundingBoxes: (boxes: BoundaryBox[]) => Promise<void>;
  isUpdating: boolean;
  canEdit: boolean;
  notification: { result: string; reason: string; message: string; subject: string };
  updateField?: (field: string, value: string | number) => Promise<void>;
  aiWorkflow?: string;
  organizationId?: string | null;
}

const EnhanceInfoAlert = () => (
  <Alert className="border-brand-500/30 bg-brand-500/5">
    <Info className="h-4 w-4 text-brand-500" />
    <AlertDescription className="text-xs">
      <strong>AI Enhance</strong> will use your query text, data tags, and Area of Interest colours to generate an optimised query. For best results, complete all three sections before clicking.
    </AlertDescription>
  </Alert>
);

export const GeminiReasoningWorkflow = (props: WorkflowProps) => (
  <BaseWorkflowPanel
    {...props}
    roiTitle="Area of Interest (AoI)"
    enhanceButtonLabel="AI Enhance Query"
    enhanceButtonSubtitle="Uses Query, Tags & AoI"
    enhanceInfoAlert={<EnhanceInfoAlert />}
    showAoiShortcut
  />
);